import * as types from "../redux/types";
import backend from "../api/api";
import { store } from "../redux/store";

const getConfig = () => {
  const token = store.getState().auth.token;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  return config;
};

export const createProduct = (formValues) => async (dispatch) => {
  console.log(formValues);
  try {
    const response = await backend.post(
      "api/product/Details/",
      formValues,
      getConfig()
    );
    if (response.status === 201) {
      dispatch({
        type: types.CREATE_PRODUCT_DETAILS,
        payload: { ...response.data },
      });
      return response.data;
      // history.push("/product/attribute");
    }
  } catch (error) {
    console.log(error);
  }
};

export const getProduct = () => async (dispatch) => {
  try {
    const response = await backend.get("api/product/Details/", getConfig());
    if (response.status === 200) {
      dispatch({
        type: types.GET_ALL_PRODUCT_DETAILS,
        payload: response.data,
      });
    }
  } catch (error) {
    console.log(error);
  }
};

// export const deleteAttribute = (id) => async (dispatch) => {
//   try {
//     const response = await backend.delete(
//       `product/attribute/${id}/`,
//       getConfig()
//     );
//     if (response.status === 204) {
//       dispatch({ type: types.DELETE_ATTRIBUTE, payload: id });
//     }
//   } catch (error) {
//     console.log(error);
//   }
// };

export const updateProduct = (id, formValues) => async (dispatch) => {
  try {
    const response = await backend.patch(
      `api/product/Details/${id}/`,
      formValues,
      getConfig()
    );
    if (response.status === 200) {
      dispatch({
        type: types.UPDATE_PRODUCT_DETAILS,
        payload: { ...response.data },
      });
    }
  } catch (error) {
    console.log(error.response);
  }
};

export const getallProductSearchResult =
  (keyward, location, page = 1, page_size = 10) =>
  async (dispatch) => {
    try {
      const response = await backend.get(
        `api/product/Details/?keyward=${keyward}&Warehouse=${location}&page=${page}&page_size${page_size}`,
        getConfig()
      );

      if (response.status === 200) {
        dispatch({
          type: types.GET_SPECIFIC_PRODUCT_DETAILS,
          payload: response.data,
        });
        return response.data;
      }
    } catch (error) {
      alert(error);
    }
  };

export const getProductSearchResult =
  (keyward, location, page = 1, page_size = 10, is_active = true) =>
  async (dispatch) => {
    try {
      const response = await backend.get(
        `api/product/Details/?keyward=${keyward}&Warehouse=${location}&page=${page}&page_size${page_size}&is_active=${is_active}`,
        getConfig()
      );

      if (response.status === 200) {
        dispatch({
          type: types.GET_SPECIFIC_PRODUCT_DETAILS,
          payload: response.data,
        });
        return response.data;
      }
    } catch (error) {
      alert(error);
    }
  };

export const getProductSearchResultforsales =
  (keyward, location, page = 1, page_size = 10, parentCategory = "", Attributes = "", lowrange = "", heighrange = "", zeroStock = false, Brand = "", Tag = "", audit_health_stat="") =>
  async (dispatch) => {
    try {
      const response = await backend.get(
        `api/product/Details/?keyward=${keyward}&Warehouse=${location}&page=${page}&page_size=${page_size}&is_active=true&parentCategory=${parentCategory}&Attributes=${Attributes}&lowrange=${lowrange}&heighrange=${heighrange}&zero_stock=${zeroStock}&Brand=${Brand}&Tag=${Tag}&audit_health_stat=${audit_health_stat}`,
        getConfig()
      );

      if (response.status === 200) {
        dispatch({
          type: types.GET_SPECIFIC_PRODUCT_DETAILS,
          payload: response.data,
        });
        return response.data;
      }
    } catch (error) {
      alert(error);
    }
  };

  // Inactive Stock Product
export const getProductSearchResultforInactiveStock =
  (keyward, location, page = 1, page_size = 10, parentCategory = "", Attributes = "", lowrange = "", heighrange = "", zeroStock = false, Brand = "", Tag = "", audit_health_stat="") =>
  async (dispatch) => {
    try {
      const response = await backend.get(
        `api/product/Details/?keyward=${keyward}&Warehouse=${location}&page=${page}&page_size=${page_size}&is_active=false&parentCategory=${parentCategory}&Attributes=${Attributes}&lowrange=${lowrange}&heighrange=${heighrange}&zero_stock=${zeroStock}&Brand=${Brand}&Tag=${Tag}&audit_health_stat=${audit_health_stat}`,
        getConfig()
      );

      if (response.status === 200) {
        dispatch({
          type: types.GET_SPECIFIC_PRODUCT_DETAILS,
          payload: response.data,
        });
        return response.data;
      }
    } catch (error) {
      alert(error);
    }
  };

export const updateAuditQuantity = (formData) => async (dispatch) => {
  try {
    const response = await backend.post(
      "api/product/Details/audit_entry/",
      formData,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const resetAuditQuantity = (location="") => async () => {
  try {
    const response = await backend.get(
      `api/product/Details/audit_entry_reset/?location=${location}`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const getAuditReport = (location = "") => async () => {
  try {
    const response = await backend.get(
      `api/product/auditreport?location=${location}`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

// Audit Report
export const saveAuditReport = (formData) => async () => {
  try {
    const response = await backend.post(
      `api/product/productaudit/`,
      formData,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const getAllAuditReport = (page=1,page_size=10) => async () => {
  try {
    const response = await backend.get(
      `api/product/productaudit?page=${page}&page_size=${page_size}`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};



  // GETIGN TRANSFER PRODUCT DETAILS WITH TAG AND BRAND FILTERS
  export const getProductSearchResultforTransfer =
  (
    keyward, 
    location, 
    page = 1, 
    page_size = 10, 
    parentCategory = "", 
    Attributes = "", 
    lowrange = "", 
    heighrange = "",
    Tag = "",           
    Brand = ""          
  ) =>
  async (dispatch) => {
    try {
      const response = await backend.get(
        `api/product/transferProductDetails/?keyward=${keyward}&Warehouse=${location}&page=${page}&page_size=${page_size}&quantity=0&is_active=true&parentCategory=${parentCategory}&Attributes=${Attributes}&lowrange=${lowrange}&heighrange=${heighrange}&Tag=${Tag}&Brand=${Brand}`,
        getConfig()
      );

      if (response.status === 200) {
        dispatch({
          type: types.GET_SPECIFIC_PRODUCT_DETAILS,
          payload: response.data,
        });
        return response.data;
      }
    } catch (error) {
      alert(error);
    }
  };

  export const getProductSearchResultForExchange =
  (keyward, location, page = 1, page_size = 10, parentCategory = "") =>
  async (dispatch) => {
    try {
      const response = await backend.get(
        `api/product/Details/?keyward=${keyward}&Warehouse=${location}&page=${page}&page_size=${page_size}&quantity=0&is_active=true&parentCategory=${parentCategory}`,
        getConfig()
      );

      if (response.status === 200) {
        dispatch({
          type: types.GET_SPECIFIC_PRODUCT_DETAILS,
          payload: response.data,
        });
        return response.data;
      }
    } catch (error) {
      alert(error);
    }
  };

export const getProductSearchResultforpackaging =
  (keyward, location, page = 1, page_size = 10, parentCategory = 52) =>
  async (dispatch) => {
    try {
      const response = await backend.get(
        `api/product/Details/?keyward=${keyward}&Warehouse=${location}&page=${page}&page_size=${page_size}&quantity=0&is_active=true&parentCategory=${parentCategory}`,
        getConfig()
      );

      if (response.status === 200) {
        // let allitem = response.data.results.filter(
        //   (item) => item.parent_category == "PACKAGING"
        // );
        // response.data.results = allitem;
        // response.data.count = allitem.length;
        dispatch({
          type: types.GET_SPECIFIC_PRODUCT_DETAILS,
          payload: response.data,
        });
        // console.log(
        //   response.data.results.filter(
        //     (item) => item.parent_category == "PACKAGING"
        //   )
        // );
        return response.data;
      }
    } catch (error) {
      alert(error);
    }
  };

export const getProductSearchResultformaterial =
  (keyward, location, page = 1, page_size = 10, parentCategory = 52) =>
  async (dispatch) => {
    try {
      const response = await backend.get(
        `api/product/Details/?keyward=${keyward}&Warehouse=${location}&page=${page}&page_size=${page_size}&is_active=true&parentCategory=${parentCategory}`,
        getConfig()
      );

      if (response.status === 200) {
        // let allitem = response.data.results.filter(
        //   (item) => item.parent_category == "PACKAGING"
        // );
        // response.data.results = allitem;
        // response.data.count = allitem.length;
        dispatch({
          type: types.GET_SPECIFIC_PRODUCT_DETAILS,
          payload: response.data,
        });
        // console.log(
        //   response.data.results.filter(
        //     (item) => item.parent_category == "PACKAGING"
        //   )
        // );
        return response.data;
      }
    } catch (error) {
      alert(error);
    }
  };

export const getProductSearchResultbywarehouse =
  (keyward, location, page = 1, page_size = 100) =>
  async (dispatch) => {
    try {
      const response = await backend.get(
        `api/product/Details/?keyward=${keyward}&Warehouse=${location}&is_outlet=False&page=${page}&page_size=${page_size}`,
        getConfig()
      );

      if (response.status === 200) {
        dispatch({
          type: types.GET_SPECIFIC_PRODUCT_DETAILS,
          payload: response.data,
        });
        return response.data;
      }
    } catch (error) {
      alert(error);
    }
  };


  export const getSingleProductSearchResultbywarehouse =
  (keyward, page = 1, page_size = 100) =>
  async (dispatch) => {
    try {
      const response = await backend.get(
        `api/product/singpleproduct/?keyward=${keyward}&page=${page}&page_size=${page_size}`,
        getConfig()
      );

      if (response.status === 200) {
        dispatch({
          type: types.GET_SPECIFIC_PRODUCT_DETAILS,
          payload: response.data,
        });
        return response.data;
      }
    } catch (error) {
      alert(error);
    }
  };


  export const getSingleProductSearchResultbyBatch =
  (keyward, location, batch="", page = 1, page_size = 100) =>
  async (dispatch) => {
    try {
      const response = await backend.get(
        `api/product/Details/?keyward=${keyward}&Warehouse=${location}&batch_no=${batch}&page=${page}&page_size=${page_size}`,
        getConfig()
      );

      if (response.status === 200) {
        dispatch({
          type: types.GET_SPECIFIC_PRODUCT_DETAILS,
          payload: response.data,
        });
        return response.data;
      }
    } catch (error) {
      alert(error);
    }
  };

  

export const getProductSearchResultResponse = (data) => async (dispatch) => {
  try {
    const response = await backend.get(
      `api/product/getvariations/${data}/`,
      getConfig()
    );

    if (response.status === 200) {
      dispatch({
        type: types.GET_SPECIFIC_PRODUCT_DETAILS_FROM_STOCK,
        payload: response.data,
      });
      return response.data;
    }
  } catch (error) {
    alert(error);
  }
};
// export const createAttributeTerm =
//   (formValues, attributeid) => async (dispatch) => {
//     formValues.Attribute = attributeid;
//     try {
//       const response = await backend.post(
//         "product/term/",
//         { ...formValues },
//         getConfig()
//       );
//       if (response.status === 201) {
//         dispatch({
//           type: types.CREATE_ATTRIBUTE_TERM,
//           payload: { ...response.data },
//         });
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };
// export const deleteAttributeTerm = (id) => async (dispatch) => {
//   try {
//     const response = await backend.delete(`product/term/${id}/`, getConfig());
//     if (response.status === 204) {
//       dispatch({ type: types.DELETE_ATTRIBUTE_TERM, payload: id });
//     }
//   } catch (error) {
//     console.log(error);
//   }
// };

// export const updateAttributeTerm = (id, formValues) => async (dispatch) => {
//   try {
//     const response = await backend.patch(
//       `product/term/${id}/`,
//       formValues,
//       getConfig()
//     );
//     if (response.status === 200) {
//       dispatch({
//         type: types.UPDATE_ATTRIBUTE_TERM,
//         payload: { ...response.data },
//       });
//     }
//   } catch (error) {
//     console.log(error.response);
//   }
// };

export const uploadProductImage = (formData, porductid) => async (dispatch) => {
  try {
    const response = await backend.post(
      "api/product/image/",
      formData,
      getConfig()
    );
    if (response.status === 201) {
      dispatch({
        type: types.CREATE_PRODUCT_DETAILS,
        payload: { ...response.data },
      });
      // history.push("/product/image/" + porductid);
    }
  } catch (error) {
    console.log(error);
  }
};

export const deleteProductImage = (id, porductid) => async (dispatch) => {
  try {
    const response = await backend.delete(
      `api/product/image/${id}/`,
      getConfig()
    );
    if (response.status === 204) {
      dispatch({ type: types.DELETE_PRODUCT_DETAILS, payload: id });
    }
  } catch (error) {
    console.log(error);
  }
};
